module.exports = __webpack_public_path__ + "img/pin-protection.4433f2c1.jpg";